import { useEffect } from 'react';
import { useUnmountEffect } from '@/shared/hooks';
import { useFullScreenLoaderContext } from './FullScreenLoaderProvider';

export const useFullScreenLoaderEffect = (isLoaderVisible?: boolean) => {
  const { showLoader, hideLoader } = useFullScreenLoaderContext();

  useEffect(() => {
    if (isLoaderVisible) {
      showLoader(Infinity);
    } else {
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaderVisible]);

  useUnmountEffect(hideLoader);
};
